/**
 * Temas disponíveis na aplicação.
 */
export enum ThemesEnum {
  LIGHT = 'LIGHT_PJ',
  DARK = 'DARK_PJ',
}
